import { createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';

import {
    selectRecommendationsSelectionsIds,
    selectShouldQueryRecommendations,
} from '~Betslip/selectors/recommendationsSelectors';


export const getRecommendations = createAsyncThunk(
    'betslip/getRecommendations',
    async (_, { getState, rejectWithValue }) => {
        const selections = selectRecommendationsSelectionsIds(getState());

        const url = buildSpectateUrl(`/recommendations_requests/getRecommendationsBetslip?selections=${selections}`);

        const response = await get(url);
        if (!response.ok) {
            rejectWithValue([]);
        }

        return response.json();
    },
    {
        condition: (_, { getState }) => {
            const shouldQueryRecommendations = selectShouldQueryRecommendations(getState());

            return shouldQueryRecommendations;
        },
    }
);
